<template>
  <div class="sub-content">
    <div class="sub-nav" ref="meun">
      <div v-for="menu in menuList" :key="menu.path">

        <router-link v-if="showPath(menu.name)" :to="menu.path" v-slot="{ navigate, isActive, isExactActive }">
          <div class="sub-nav__li" :class="[
            isActive && 'router-link-active',
            isExactActive && 'router-link-exact-active',
            !showSecondMenu && 'router-link-pack-up',

            menu.children && menu.children.length > 0
              ? 'sub-nav__li--has-child'
              : 'sub-nav__li--pointer'
          ]" @click="clickMenu($event, menu.path, navigate,menu)">
            <span class="sub-nav__icon"><img :src="menu.img" alt="" width="16" height="16"></span>
            <div class="sub-nav__title">{{ menu.title }}</div>
            <div
              v-if="menu.children && menu.children.length > 0"
              class="sub-nav__icon__down v-icon-down"
            ></div>
          </div>

        </router-link>
        <collapse-transition>
          <div v-if="menu.children &&
           menu.children.length > 0 &&
            showSecondMenu&&
               fullPath.indexOf(menu.path) === 0
                 " class="sub-nav__second" >
            <div>
              <template v-for="secondMenu in menu.children">
                <router-link v-if="showPath(secondMenu.name)" :key="secondMenu.path"
                  :to="menu.path + '/' + secondMenu.path" v-slot="{ navigate, isActive, isExactActive }">
                  <div class="sub-nav__second__li sub-nav__li--pointer" :class="[
                    isActive && 'router-link-active',
                    isExactActive && 'router-link-exact-active'
                  ]" @click="
                      clickMenu(
                        $event,
                        menu.path + '/' + secondMenu.path,
                        navigate
                      )
                    ">
                    <div class="sub-nav__title">{{ secondMenu.title }}</div>
                  </div>
                </router-link>
              </template>
            </div>
          </div>
        </collapse-transition>
      </div>
    </div>
    <div class="sub-main-content">
      <router-view v-if="isReload"></router-view>
    </div>
  </div>
</template>

<script>
import { MENU } from "@/router/menu";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["hideMenu"]),
  },
  data() {
    return {
      isReload: true,
      menuList: [],
      showSecondMenu: true,
      fullPath: ""
    };
  },
  created() {
    this.menuList = MENU;
  },
  methods: {
    showPath(name) {
      //将有权限的的页面展示出来
      return this.hideMenu.indexOf(name) === -1;
    },
    reload() {
      this.isReload = false;
      this.$nextTick(() => {
        this.isReload = true;
      });
    },
    clickMenu($event, path, navigate,menu) {
      let fullPath = this.$route.fullPath;
      if (path === fullPath) {
        this.reload();
      } else if (
        this.$route.matched[1] &&
        path == this.$route.matched[1].path
      ) {
        // 如果是当前菜单的点击 就收起 或展开
        this.showSecondMenu = !this.showSecondMenu;
      } else if (menu && menu.children) {
        //若redirect的路由被隐藏，则显示下一个路由
        let existMenu = menu.children.filter(
            item => !this.hideMenu.includes(item.name)
          ),
          redirectName = menu.children[0].name;
        if (this.hideMenu.includes(redirectName)) {
          this.$router.push(path + "/" + existMenu[0].path);
        } else {
          navigate($event);
        }
        this.showSecondMenu = true
      } else {
        this.showSecondMenu = true;
        navigate($event);
      }
    }
  },
  watch: {
    "$route.fullPath": {
      handler(val) {
        this.fullPath = val;
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="scss">
.sub-content{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.sub-nav {
  min-height: calc(100vh - 12px - #{$header-height});
  width: $menu-width;
  border-right: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;

  &__icon {
    position: absolute;
    line-height: 54px;
    left: 30px;
    font-size: 16px;

    &__down {
      position: absolute;
      right: 16px;
      line-height: 48px !important;
      transition: all 0.2s;
    }
  }

  &__li {
    position: relative;
    font-size: 14px;
    height: 48px;
    cursor: pointer;

    &--pointer {
      &.router-link-active {
        background-color: $menu-active-color;
        color: $main-active-color;

        &::after {
          @extend .sub-nav__second__li.router-link-active;
        }
      }
    }

    &--has-child {
      &.router-link-active {
        color: $main-active-color;

        .sub-nav__icon__down {
          transform: rotateZ(180deg);
        }
      }
      &.router-link-active.router-link-pack-up {
        .sub-nav__icon__down {
          transform: rotateZ(0deg);
        }
      }
    }

    &:hover {
      background-color: $menu-active-color;
    }
  }

  &__title {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    padding-left: 56px;
    padding-right: 32px;
  }

  &__second__li {
    height: 40px;
    position: relative;
    cursor: pointer;

    &.router-link-active {
      &::after {
        content: "";
        position: absolute;
        right: 0;
        height: 100%;
        width: 2px;
        background: $main-active-color;
      }
    }

    &:hover {
      background-color: $menu-active-color;
    }
  }
}

.sub-main-content {
  // overflow:scroll;
  position: relative;
  vertical-align: top;
  padding: 24px 24px 0;
  height: calc(100vh - 13px - #{$header-height});
  width: calc(100vw - #{$menu-width});
}
.menu-img{
  width: 16px;
  height: 16px;
}
</style>
